var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconHome(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.1605 6.00004L8.88047 1.52004C8.36047 1.12004 7.64047 1.12004 7.12047 1.48004L0.880473 5.76004C0.600473 5.96004 0.520473 6.32004 0.720473 6.60004C0.920473 6.88004 1.28047 6.96004 1.56047 6.76004L2.40047 6.16004V11.08C2.40047 12.92 3.88047 14.4 5.72047 14.4H10.2805C12.1205 14.4 13.6005 12.92 13.6005 11.08V6.36004L14.4405 6.96004C14.5605 7.04004 14.6805 7.08004 14.8005 7.08004C15.0005 7.08004 15.1605 7.00004 15.2805 6.84004C15.4805 6.56004 15.4005 6.20004 15.1605 6.00004ZM12.4005 11.08C12.4005 12.24 11.4405 13.2 10.2805 13.2H5.72047C4.56047 13.2 3.60047 12.24 3.60047 11.08V5.32004L7.84047 2.44004C7.92047 2.36004 8.04047 2.36004 8.16047 2.44004L12.4005 5.48004V11.08Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconHome);
export default __webpack_public_path__ + "static/media/icon-home.b1035cc4d5c9d6586beb05759ab0b566.svg";
export { ForwardRef as ReactComponent };